import React from 'react';

const SkipLink: React.FC = () => {
  return (
    <a
      href="#main-content"
      className="skip-link absolute -top-10 left-4 bg-sky-600 text-white px-4 py-2 rounded-md z-50 focus:top-4 transition-all duration-200"
      tabIndex={0}
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;